import { useTranslation } from "react-i18next";
import AlertMessageModal from "../alertMessageModal";
import { useState } from "react";
import { downloadDocument } from "../../utils/helpers";
import { useSelector } from "react-redux";

const ButtonLogOut = (props: any) => {

  let titleLogOut = props.title ?? "";
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div>
       
        {titleLogOut && <h5 className="d-inline mr-3">{titleLogOut}</h5>}

        <button onClick={() => setShowModal(true)} className="iconButton mt-1">
          <span className="material-symbols-outlined">power_settings_new</span>
        </button>
      </div>
      <AlertMessageModal
        title={t("attention")}
        description={t("popup-logout.message")}
        closeModal={() => setShowModal(false)}
        titleButtonPrimary={t("popup-logout.button-logout")}
        handleClosePrimary={props.handleClick}
        titleButtonSecondary={t("popup-logout.button-cancel")}
        handleCloseSecondary={() => setShowModal(false)}
        show={showModal}
      />
    </>
  );
};

export default ButtonLogOut;
